(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siybr-process-film-strip"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('siybr-process-film')) {

    class SiybrProcessFilm extends HTMLElement {

      connectedCallback() {

        this.track =
          this.querySelector(
            '[data-pf-track]'
          );

        this.frames =
          [
            ...this.querySelectorAll(
              '[data-pf-frame]'
            )
          ];

        this.nav =
          [
            ...this.querySelectorAll(
              '[data-pf-nav]'
            )
          ];

        this.activeNumber =
          this.querySelector(
            '[data-pf-active-number]'
          );

        this.activeTitle =
          this.querySelector(
            '[data-pf-active-title]'
          );

        this.activeSteps =
          this.querySelector(
            '[data-pf-active-steps]'
          );

        this.current = 0;

        if (
          !this.track
          ||
          !this.frames.length
        ) {
          return;
        }


        /* -----------------------------------------
           NAV CLICK
        ----------------------------------------- */

        this.onNavClick =
          (event) => {

            const button =
              event.currentTarget;

            this.setActive(
              Number(
                button.dataset.pfNav
              ),
              true
            );
          };

        this.nav.forEach(
          (button) =>
            button.addEventListener(
              'click',
              this.onNavClick
            )
        );


        /* -----------------------------------------
           KEYBOARD NAV
        ----------------------------------------- */

        this.onKeydown =
          (event) => {

            if (
              event.key
              ===
              'ArrowRight'
            ) {

              event.preventDefault();

              this.setActive(
                Math.min(
                  this.current + 1,
                  this.frames.length - 1
                ),
                true
              );

            } else if (
              event.key
              ===
              'ArrowLeft'
            ) {

              event.preventDefault();

              this.setActive(
                Math.max(
                  this.current - 1,
                  0
                ),
                true
              );
            }
          };

        this.track.addEventListener(
          'keydown',
          this.onKeydown
        );


        /* -----------------------------------------
           ACTIVE FRAME DETECTION
        ----------------------------------------- */

        if (
          'IntersectionObserver'
          in
          window
        ) {

          this.observer =
            new IntersectionObserver(

              (entries) => {

                const visible =
                  entries
                    .filter(
                      (entry) =>
                        entry.isIntersecting
                    )
                    .sort(
                      (a, b) =>
                        b.intersectionRatio
                        -
                        a.intersectionRatio
                    )[0];

                if (!visible) {
                  return;
                }

                const index =
                  this.frames.indexOf(
                    visible.target
                  );

                if (
                  index > -1
                  &&
                  index !== this.current
                ) {

                  this.setActive(
                    index,
                    false
                  );
                }
              },

              {
                root: this.track,

                threshold:
                  [
                    0.5,
                    0.65,
                    0.8
                  ]
              }
            );

          this.frames.forEach(
            (frame) =>
              this.observer.observe(
                frame
              )
          );
        }


        /* -----------------------------------------
           SHOPIFY THEME EDITOR
        ----------------------------------------- */

        this.onBlockSelect =
          (event) => {

            if (
              event.detail.sectionId
              !==
              this.dataset.sectionId
            ) {
              return;
            }

            const index =
              this.frames.findIndex(
                (frame) =>
                  frame.dataset.blockId
                  ===
                  event.detail.blockId
              );

            if (index > -1) {

              this.setActive(
                index,
                true
              );
            }
          };

        document.addEventListener(
          'shopify:block:select',
          this.onBlockSelect
        );


        /* Initial */

        this.setActive(
          0,
          false
        );
      }


      disconnectedCallback() {

        this.observer?.disconnect();

        this.nav?.forEach(
          (button) =>
            button.removeEventListener(
              'click',
              this.onNavClick
            )
        );

        this.track?.removeEventListener(
          'keydown',
          this.onKeydown
        );

        document.removeEventListener(
          'shopify:block:select',
          this.onBlockSelect
        );
      }


      /* =========================================
         SET ACTIVE STAGE
      ========================================= */

      setActive(
        index,
        shouldScroll
      ) {

        const frame =
          this.frames[index];

        if (!frame) {
          return;
        }

        this.current = index;


        /* Frame state */

        this.frames.forEach(
          (item, i) =>

            item.classList.toggle(
              'is-active',
              i === index
            )
        );


        /* Nav state */

        this.nav.forEach(
          (button, i) =>

            button.setAttribute(
              'aria-current',
              i === index
                ?
                'true'
                :
                'false'
            )
        );


        /* Dynamic status */

        if (this.activeNumber) {

          this.activeNumber.textContent =
            frame.dataset.stageNumber
            ||
            String(
              index + 1
            ).padStart(
              2,
              '0'
            );
        }

        if (this.activeTitle) {

          this.activeTitle.textContent =
            frame.dataset.stageTitle
            ||
            '';
        }

        if (this.activeSteps) {

          this.activeSteps.textContent =
            frame.dataset.stageSteps
            ||
            '';
        }


        /* Smooth scroll */

        if (shouldScroll) {

          const reduceMotion =
            window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;

          frame.scrollIntoView({

            behavior:
              reduceMotion
                ?
                'auto'
                :
                'smooth',

            block:
              'nearest',

            inline:
              'center'
          });
        }
      }
    }


    customElements.define(
      'siybr-process-film',
      SiybrProcessFilm
    );
  }


  } catch(e) { console.error(e); }
})();
})();
